import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { Basket } from '@df/session/api/basket/basket';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[pageHeaderBasketQtyBullet]'
})
export class PageHeaderBasketQtyBulletDirective implements OnDestroy {
    private subascription = new Subscription();

    /**
     * In basket qty
     */
    private qty = 0;

    constructor(private basket: Basket, private renderer2: Renderer2, private elementRef: ElementRef) {
        basket.subscribe(() => this.update());
        this.update();
    }

    private update() {
        const qty = this.basket.qty;
        if (this.qty !== qty) {
            const element = this.elementRef.nativeElement;
            this.qty = qty;
            if (qty) {
                this.renderer2.setAttribute(element, 'qty-bullet', qty + '');
            } else {
                this.renderer2.removeAttribute(element, 'qty-bullet');
            }
            this.renderer2.setAttribute(element, 'aria-label', `Basket quantity ${qty}`);
        }
    }

    ngOnDestroy(): void {
        this.subascription.unsubscribe();
    }
}
